export default (value) => {
  return `$${parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
  })}`;
};
